import { ITabInternal } from "../interfaces";
import { GaTab } from "./gaia/GaTab";

export const Tab = (props : ITabInternal) => {
    const { title, isActive, onClick } = props;

    if (window.useGaiaDesign) {
        return <GaTab {...props} />;
    }
    
    return (
        <button className={`btn ar-tab-button ${isActive ? "ar-tab-active" : "ar-tab-inactive"}`} onClick={onClick} title={title}>{title}</button>
    );
}
